<template>
	<section class="ecosizer-intro page-content py-5">
		<div class="container">
			<div class="row justify-content-between intro-content">
				<div class="col-5">
					<header class="page-header">
						<h1 class="color-green mb-4">Electrifying water heating is a major decarbonization strategy. </h1>
					</header>

					<p class="update-notice">Ecosizer was updated on 9/22/26 to add supplemental heating configuration sizing. Please contact hpwh@ecotope.com with questions, concerns, or if you encounter any bugs.</p>

					<p>The Ecosizer is a free tool for sizing central water heating systems based on commercial heat pump water heaters (CHPWHs) in multifamily and commercial buildings. The tool is designed to support the building industry to adopt CHPWHs to improve energy efficiency and reduce greenhouse gas emissions. The Ecosizer is also intended to provide educational information on CHPWH system designs to other stakeholders, for example energy efficiency and building decarbonization advocates, program administrators and implementors, building science researchers, manufacturers, and policy makers.</p>

					<a href="/sizer/docs" class="btn mt-5">
						<span>More Information</span>
						<i class="symbol circle">
							<svg aria-hidden="true">
								<use xlink:href="/static/build/gfx/sprite.svg#symbol-forward"></use>
							</svg>
						</i>
					</a>
				</div>

				<div class="col-6">
					<h6 class="mt-2 mb-3">how to use this tool</h6>
					<ol class="howto">
						<li>Identify weather conditions (cold water temperature and ambient temperature) on the design day, which is usually the coldest day of the year.</li>
						<li>Select a HPWH technology and identify its temperature setpoint limitations. Consider its potential performance limitations under winter design conditions.</li>
						<li>Provide input method and values to determine design-day hot water demand.</li>
						<li>Provide the storage, delivery, and incoming water temperature settings for your system.</li>
						<li>Select the configuration for the temperature maintenance system. </li>
						<li>Revise default values for advanced inputs, if needed.</li>
						<li>Click “Size Your System” to obtain minimum sizing results and the Primary Sizing Curve.</li>
						<li>Select the actual HPWH heating capacity according to performance characteristics of the selected HPWH technology. Use the Primary Sizing Curve to find the minimum storage volume based on the actual HPWH design-day heating capacity. Alternatively, select a storage volume first and use the Primary Sizing Curve to find the corresponding HPWH output capacity needed to meet the design-day hot water demand. </li>
					</ol>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'DefaultSizerIntro',
}
</script>

<style scoped>
.update-notice {
	color: #dc3545;
	font-weight: 500;
	margin-bottom: 1rem;
}
</style>
